import { AIUserFeedback } from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import { AxiosInstance } from 'axios'

export const updateAIUserFeedback = async (
  apiClient: AxiosInstance,
  feedback: AIUserFeedback
): Promise<AIUserFeedback> => {
  const { data } = await apiClient.patch<AIUserFeedback>(
    `/api/ai-user-feedback/${feedback.uuid}`,
    feedback
  )

  return data
}
